import axios from 'axios'

export default class Mandatos {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/dominios/tipoMandatoComCargo`
    this.tokenBearer = tokenBearer
  }

  async getDominio (id = '') {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}/${id}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
